import React from "react";
import Button from "../../components/common/Button";
import { ModalContainer, ModalTextCenter } from "../../common/modal.styles";

interface InfoModalProps {
  description: string;
  buttonText: string;
  onClick?: () => void;
  url?: string;
}

export function InfoModal({ description, buttonText, onClick, url }: InfoModalProps) {
  return (
    <ModalContainer>
      <ModalTextCenter>{description}</ModalTextCenter>
      <Button
        id="btn"
        type="button"
        variant="primary"
        target="_self"
        height="48px"
        text={buttonText}
        onClick={onClick}
        url={url}
        fullWidth
      />
    </ModalContainer>
  );
}
